/**
 * WikiPageEmitter — 채팅 → 위키 페이지 변환 이벤트 중개
 *
 * MessagePopover → WikiPageCreateModal 연결.
 * TaskEmitter / MemoModalEmitter 패턴과 동일.
 */
import EventEmitter from 'eventemitter3';

export const WikiPageEmitter = new EventEmitter();

/**
 * 이벤트 시그니처:
 * - 'create' (threadText: string, roomId: string, threadMessageId: string)
 *   → WikiPageCreateModal 열기 (현재 채널의 위키 게시판에 저장).
 *     이 이벤트는 채널에 위키 게시판이 이미 존재할 때만 발행한다.
 *
 * - 'created' (roomId: string, boardId: string, postId: string)
 *   → 위키 페이지 저장 완료 → 사이드바/리스트 갱신 등에 활용.
 *
 * - 'open' (boardId: string, postId: string)
 *   → 외부에서 특정 위키 페이지 열기.
 */
